import { makeStyles, Typography } from "@material-ui/core";

import { Box } from "@material-ui/core";
import { getPercent, nKilowattFormatter } from "../../services";

import { COLORS } from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: COLORS.darks[0][100],
    borderRadius: 8,
    padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    zIndex: 2,
  },
  title: {
    color: COLORS.white,
    fontWeight: 700,
  },
  description: {
    color: COLORS.white,
    fontWeight: 400,
    fontSize: 10,
  },
}));

export const CustomPieChartTooltipContent = ({ active, payload, total, chartTypeName }) => {
  const classes = useStyles();

  if (active && payload && payload.length) {
    const suffix = chartTypeName[chartTypeName.length - 1];
    return (
      <Box className={classes.root}>
        <Typography variant="body2" className={classes.title}>
          {payload[0].name}
        </Typography>
        <Typography className={classes.description}>
          {`${nKilowattFormatter(payload[0].value, suffix)}; ${getPercent(
            payload[0].value,
            total,
            2
          )} %`}
        </Typography>
      </Box>
    );
  }

  return null;
};
